import React from 'react';

/**
 * Marquee — an infinite horizontal ticker used as a section divider,
 * with keywords scrolling in yellow. Pauses on hover.
 */
export function Marquee({ items = [], speed = 28, separator = '✦' }) {
  const content = items.length ? items : ['Bernardo Assad'];
  // `startIndex` carries the color parity across rows so the alternation
  // stays continuous at the seam — no two same-colored items end up adjacent,
  // regardless of how many items there are.
  const Row = ({ startIndex = 0 }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-6)', paddingRight: 'var(--space-6)', flexShrink: 0 }}>
      {content.map((it, i) => (
        <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--space-6)' }}>
          <span style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--text-h2)', fontWeight: 'var(--weight-bold)', letterSpacing: 'var(--tracking-tight)', color: (startIndex + i) % 2 ? 'var(--text-primary)' : 'var(--text-accent)', whiteSpace: 'nowrap' }}>
            {it}
          </span>
          <span style={{ color: 'var(--accent)', fontSize: 'var(--text-lg)' }}>{separator}</span>
        </span>
      ))}
    </div>
  );

  return (
    <div
      style={{ display: 'flex', overflow: 'hidden', maskImage: 'linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)', WebkitMaskImage: 'linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)' }}
      onMouseEnter={(e) => { e.currentTarget.querySelectorAll('[data-track]').forEach((t) => (t.style.animationPlayState = 'paused')); }}
      onMouseLeave={(e) => { e.currentTarget.querySelectorAll('[data-track]').forEach((t) => (t.style.animationPlayState = 'running')); }}
    >
      <div data-track style={{ display: 'flex', animation: `ba-marquee ${speed}s linear infinite` }}>
        <Row startIndex={0} />
        <Row startIndex={content.length} />
      </div>
    </div>
  );
}

export default Marquee;
